import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history }) {
  useEffect(() => {
      const unlisten = history.listen(() => {
        try {
            if (document.getElementsByClassName("full")[0]) {
              document.getElementsByClassName("full")[0].scrollTo(0,0);
            }
          } catch (error) {
              console.error(error);
          }
    });
    return () => {
      unlisten();
    }
  }, [history]);

  return (null);
}

export default withRouter(ScrollToTop);